const angular = require('angular');
const moment = require("moment/moment");
const app = angular.module('learn-directives');
/**
 * Defines the manager badges component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('managerUserBadges', ['Application', 'Badges', function (Application, Badges) {
    return {
        restrict: 'E',
        scope: {
            user: '='
        },
        replace: true,
        template: require('../../../templates/directives/manager/manager-user-badges.html'),
        controller: ['$scope', function ($scope) {
            var self = this;
            self.page = 0;
            self.per_page = 5;
            self.currentBadges = [];
            self.dateUp = false;
            self.sort = -1;
            self.query = {};
            self.actions = {
                navContent: () => {
                    Application.navigation.goTo('/overview/badges/' + id);
                },
                nextPage: () => {
                    self.page++;
                    self.load();
                },
                previousPage: () => {
                    self.page--;
                    self.load();
                },
                sortDate () {
                    self.dateUp = !self.dateUp;
                    if (self.dateUp){
                        self.sort = -1;
                    } else {
                        self.sort = 1;
                    }
                    self.load();
                },
                onSearch: function(items) {
                    self.query = {};
                    const badges = [];
                    let text = '';
                    items.forEach(item => {
                        if (item._id) {
                            badges.push(item._id);
                        } else {
                            text = item.title;
                        }
                    });

                    if (badges.length) {
                        self.query['badge._id'] = badges;
                    }
                    if (text.length) {
                        self.query['badge.title'] = {"$regex": text, "$options": 'i'};
                    }

                    self.load();
                }
            };
            self.load = () => {
                Badges.getAwardedByUser({subsubsubresource: $scope.user.toString(), query: self.query, page: self.page, perPage: self.per_page, sort: self.sort}).$promise
                    .then((results) => {
                        self.currentBadges = results;
                    });
            };
            self.load();
        }],
        controllerAs: 'managerUserBadges'
    };
}]);